import { createFileRoute } from '@tanstack/react-router';
import { getTransactions } from '@/features/transaction-history/services/get-transactions';
import { TransactionHistoryPage } from '@/features/transaction-history/transaction-history-page';

interface TransactionHistorySearch {
	type?: string;
}

export const Route = createFileRoute('/ixi-finance/transaction-history')({
	validateSearch: (
		search: Record<string, unknown>,
	): TransactionHistorySearch => ({
		type: search.type as string | undefined,
	}),
	loader: () => getTransactions(),
	component: TransactionHistoryPage,
	ssr: false,
	shouldReload: ({ cause }) => cause !== 'stay',
});
